import data from "../../../../../src/drafts/SelectPanel2/SelectPanel.docs.json";
import * as React from 'react';
export default {
  data,
  React
};